/**
 * components/landing/ai-platform/sections/FAQ.jsx — §4.11.
 * Accordion with 6 AI-specific questions.
 */

import React, { useState } from 'react'
import clsx from 'clsx'
import { ChevronDown, HelpCircle } from 'lucide-react'
import { Container, Eyebrow, SectionHeading } from '@/components/landing/design-system'
import { FAQ as FAQ_DATA } from '../data'

export default function AIFAQ() {
  const [open, setOpen] = useState(0)
  return (
    <section className="relative py-24 md:py-28">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
      <Container className="flex flex-col gap-10">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow>Frequently asked</Eyebrow>
          <SectionHeading
            align="center"
            title={<>The questions <span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">most buyers ask about AI.</span></>}
            subtitle="If yours isn’t here, our team can answer in a 30-minute call."
          />
        </div>

        <div className="flex flex-col gap-2">
          {FAQ_DATA.map((r, i) => {
            const isOpen = open === i
            return (
              <div key={i} className={clsx(
                'rounded-2xl border transition-all',
                isOpen ? 'border-white/20 bg-white/[0.04]' : 'border-white/10 bg-white/[0.02] hover:bg-white/[0.03]',
              )}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center gap-3 p-4 md:p-5 text-left"
                >
                  <HelpCircle className={clsx('h-4 w-4 shrink-0', isOpen ? 'text-brand-gold' : 'text-zinc-500')} />
                  <span className={clsx('flex-1 text-[15px] font-semibold', isOpen ? 'text-white' : 'text-zinc-200')}>
                    {r.q}
                  </span>
                  <ChevronDown className={clsx('h-4 w-4 text-zinc-500 shrink-0 transition-transform', isOpen && 'rotate-180')} />
                </button>
                {isOpen && (
                  <div className="px-4 md:px-5 pb-4 md:pb-5 -mt-1">
                    <p className="pl-7 text-sm text-zinc-300 leading-relaxed">{r.a}</p>
                  </div>
                )}
              </div>
            )
          })}
        </div>
      </Container>
    </section>
  )
}
